import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	background: #f5f7fa;
	padding: 15px;
	border-radius: 6px;
`;

export const ContainerContent = styled.div`
	position: relative;
	background-color: ${tokens.color_white};
	padding: 12px;
	border-radius: 6px;
`;

export const ProgressContainer = styled.div`
	position: absolute;
	top: -22%;
	right: 2%;
	background: white;
	border-radius: 50%;
`;

export const ContainerHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	padding-bottom: 28px;
	padding-top: 12px;

	h3 {
		font-family: ${tokens.font_family_primary};
		font-weight: 700;
		font-size: 18px;
		color: ${tokens.color_gray_dark};
		max-width: 70%;
	}

	p {
		font-family: ${tokens.font_family_primary};
		font-weight: 700;
		font-size: 14px;
		color: ${tokens.color_primary};
	}
`;

export const ContainerContentDomain = styled.div`
	position: relative;
	padding: 12px;
`;

export const ContainerHeaderDomain = styled.div``;

export const ContainerDivision = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding-bottom: 24px;
	border-radius: 6px;

	p {
		font-family: ${tokens.font_family_primary};
		font-weight: 700;
		font-size: 14px;
		color: ${tokens.color_primary};
	}
`;

export const Line = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${tokens.color_gray_medium};
`;

export const ContainerTitle = styled.div`
	display: flex;
	justify-content: space-between;
	padding-bottom: 42px;
	gap: 12px;

	h3 {
		font-family: ${tokens.font_family_primary};
		font-weight: 700;
		font-size: 16px;
		color: ${tokens.color_gray_dark};
		max-width: 70%;
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 86px;
	width: 86px;
	border-radius: 18px;
	height: 24px;
	border: ${({ color }) => `2px solid ${color}`};
	color: ${({ color }) => color};
	font-size: 14px;
	font-weight: 600;
	font-family: ${tokens.font_family_primary};
`;
